/**
 * WTM_Libs module
 * @module WTM_Libs
 */
define(function() {

    //------------------------------------------------------------------ Create Config File
    //-------------------------------------------------------------------------------------
    /**
     * Configuration object (wtm)
     * @type {Object}
     */
    var wtm = {};
    wtm.header = {};
    wtm.mmenu = {};
    wtm.main_slider = {};
    wtm.sliders = {};
    wtm.sliders.staff = {};
    wtm.sliders.testimonial = {};
    wtm.sliders.photo = {};
    wtm.sliders.video = {};
    wtm.sliders.proflogo = {};
    wtm.sliders.map = {};
    wtm.sliders.service = {};
    wtm.widgets = {};
    wtm.widgets.photo_gallery = {};
    wtm.widgets.svg = {};
    wtm.widgets.video = {};
    wtm.widgets.maps = {};
    wtm.optional_libs = {};
    wtm.swiperObjects = {};

    //----------------------------------------------------------- Append Optional Libraries
    //-------------------------------------------------------------------------------------
    loadLib("animate_CSS_JS",
        "/core/javascript/wtm-front-end_v2.0.0/lib/animatecss/animate.css",
        "core/javascript/wtm-front-end_v2.0.0/lib/animatecss/wow.min.js");
    loadLib("awesomeFonts",
        "//maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css");
    loadLib("jqueryUI",
        "/core/javascript/wtm-front-end_v2.0.0/lib/jqueryUI/jquery-ui-1.10.4.custom.min.css",
        "/core/javascript/wtm-front-end_v2.0.0/lib/jqueryUI/jquery-ui-1.10.4.custom.min.js");
    // loadLib("customCSS",
    //     "/custom/css/custom.css");
    /**
     * @param  {string}
     * @param  {string}
     * @param  {string}
     * @return {void}
     */
    function loadLib(option, urlCSS, urlJS) {
        Object.defineProperty(wtm.optional_libs, option, {
            set: function(param) {
                if (!param) return;
                // if (!param && option !== "jqueryUI") return;
                // else {
                // let uat = location.hostname.split(".");
                // if (uat[uat.length - 1] !== "web2" && uat[uat.length - 1] !== "webtomed") return;
                // }
                var link = document.createElement("link");
                link.type = "text/css";
                link.rel = "stylesheet";
                link.href = urlCSS;
                document.getElementsByTagName("head")[0].appendChild(link);
                urlJS = urlJS || false;
                if (!urlJS) return;
                else require([urlJS]);
            }
        });
    }

    //----------------------------------------------------------------- Include Legacy Code
    //-------------------------------------------------------------------------------------
    /**
     * @param {boolean}
     * @return {void}
     */
    Object.defineProperty(wtm.optional_libs, "legacy_code", {
        set: function(param) {
            if (!param) return;
            require(['/core/javascript/jquery/js/jquery.cycle.all.custom.js']);
            require(['/core/javascript/jquery/js/jquery.ajax.js']);
            require(['/core/javascript/General.js']);
            require(['/core/javascript/jquery/js/jquery.bs.manager.js']);
        }
    });
    return wtm;
});
